import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Typography,
  IconButton,
  Stack,
  Paper,
  TextField,
  styled,
} from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import CloseIcon from '@mui/icons-material/Close';

const StyledPaper = styled(Paper)`
  transition: box-shadow 0.1s ease-in-out;
  border: 1px solid #ddd;
  border-radius: 6px;
`;

const StyledTextField = styled(TextField)`
  .MuiInputBase-root {
    border-radius: 6px;
    background-color: #f5f5f5;
  }
  .MuiOutlinedInput-notchedOutline {
    border: none;
  }
`;

interface AssignInfoDialogProps {
  open: boolean;
  onClose: () => void;
  counselingDetail: {
    판매업체: string;
    담당자: string;
    담당자이메일?: string;
    담당자전화?: string;
  };
}

const AssignInfoDialog: React.FC<AssignInfoDialogProps> = ({ open, onClose, counselingDetail }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          bgcolor: 'primary.main',
          color: 'white',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          py: 2,
        }}>
        <Stack direction="row" spacing={1} alignItems="center">
          <PersonIcon />
          <Typography variant="h6" sx={{ fontSize: '16px' }}>
            담당자 정보
          </Typography>
        </Stack>
        <IconButton onClick={onClose} sx={{ color: 'white' }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: 3 }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <StyledPaper sx={{ p: 3, mt: 3 }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography sx={{ fontSize: '12px', color: '#9a9a9a', mb: 0.5 }}>판매업체</Typography>
                  <StyledTextField value={counselingDetail.판매업체} disabled fullWidth />
                </Grid>
                <Grid item xs={12}>
                  <Typography sx={{ fontSize: '12px', color: '#9a9a9a', mb: 0.5 }}>담당자명</Typography>
                  <StyledTextField value={counselingDetail.담당자} disabled fullWidth />
                </Grid>
                <Grid item xs={12}>
                  <Typography sx={{ fontSize: '12px', color: '#9a9a9a', mb: 0.5 }}>담당자 이메일</Typography>
                  <StyledTextField value={counselingDetail.담당자이메일 || ''} disabled fullWidth />
                </Grid>
                <Grid item xs={12}>
                  <Typography sx={{ fontSize: '12px', color: '#9a9a9a', mb: 0.5 }}>담당자 휴대폰</Typography>
                  <StyledTextField value={counselingDetail.담당자전화 || ''} disabled fullWidth />
                </Grid>
              </Grid>
            </StyledPaper>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default AssignInfoDialog;
